

export default function TextYouHave() {
  return (
    <p className="text-black222 font-bold || mt-6 mb-2">
      You have no unread messages
    </p>
  );
}
